/* src/app/component/progetti/progetti.component.css */
.gridL {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1rem;
}
@media (min-width: 640px) {
  .gridL {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (min-width: 768px) {
  .gridL {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  .gridL {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {
  .gridL {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
/*# sourceMappingURL=progetti.component.css.map */
